import { render } from "./seo-settings.vue?vue&type=template&id=bd0566f4"
import script from "./seo-settings.vue?vue&type=script&lang=js"
export * from "./seo-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__